import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'models';
const actionTable = (state: RootState) => state.configurator.actionTables;
const corporateApproval = createSelector(actionTable, ({ corporateApproval }) => corporateApproval);

const selectActionsTableView = createSelector(actionTable, (actionTable) => actionTable.selectedView);

const selectTableToSearch = createSelector(actionTable, (actionTable) => actionTable.selectedTableToSearch);

const getATcompanies = createSelector(actionTable, ({ companies }) => companies);

const getSelectedCompanies = createSelector(actionTable, ({ selectedCompanies }) => selectedCompanies);

const getLeftTableRows = createSelector(actionTable, ({ leftTableRows }) => leftTableRows);

const getSelectedRow = createSelector(actionTable, ({ selectedRow }) => selectedRow);

const getSelectedRowId = createSelector(getSelectedRow, (selectedRow) => selectedRow?.id);

const getEditedRowId = createSelector(actionTable, ({ editedRowId }) => editedRowId);

const getSelectedOptionValue = createSelector(actionTable, ({ selectedOptionValue }) => selectedOptionValue);

const getCorporateApprovalList = createSelector(
  corporateApproval,
  ({ corporateApprovalList }) => corporateApprovalList,
);

const getSelectedCorporateApproval = createSelector(corporateApproval, ({ selectedRow }) => selectedRow);

const getEditedRowIdCorporateApproval = createSelector(corporateApproval, ({ editRowId }) => editRowId);

const getWfCasuals = (state: RootState) =>
  state.configurator.actionTables.wfCasuals.map((el) => {
    return {
      value: el.idWfCausal,
      label: el.causalName,
      ...el,
    };
  });

const getWfDefinitions = createSelector(actionTable, ({ wfDefinitions }) =>
  wfDefinitions.map((el) => {
    return {
      value: el.idDefinition,
      label: el.wfName,
      ...el,
    };
  }),
);

const getAllMicrocategories = createSelector(actionTable, ({ allMicroCategories }) =>
  allMicroCategories.map((el) => {
    return {
      label: `${el.code} - ${el.description}`,
      value: el.code,
      ...el,
    };
  }),
);

const getAllSubjects = createSelector(actionTable, ({ allSubjects }) =>
  allSubjects.map((el) => {
    return {
      label: `${el.supplierCode} - ${el.subject}`,
      value: el.supplierCode,
      ...el,
    };
  }),
);

const getOptionDescriptionDropdown = createSelector(
  actionTable,
  ({ optionDescriptionDropdown }) => optionDescriptionDropdown,
);

const getOptionValueDropdown = createSelector(actionTable, ({ optionValueDropdown }) => optionValueDropdown);

const getAP2OptionList = createSelector(actionTable, ({ AP2OptionsList }) => AP2OptionsList);

const getNotModifiedRow = createSelector(actionTable, ({ notModifiedRow }) => notModifiedRow);

const getSelectedAP2row = (state: RootState) => state.configurator.actionTables.selectedAP2row;

const getEditedRowAP2ID = (state: RootState) => state.configurator.actionTables.editedRowAP2ID;

const getIsEditAP2Template = (state: RootState) => state.configurator.actionTables.isEditAP2Template;

const getTemplateAP2List = (state: RootState) => state.configurator.actionTables.templateAP2List;

const getIsAddAP2Template = (state: RootState) => state.configurator.actionTables.isAddAP2Template;

const getVendorListAp2Template = (state: RootState) => state.configurator.actionTables.vendorListAp2Template;

const noPO = (state: RootState) => state.configurator.actionTables.NOPO;

const getNOPOSelectedRow = createSelector(noPO, ({ selectedRow }) => selectedRow);

const getNOPOSelectedRowId = createSelector(getNOPOSelectedRow, (selectedRow) => selectedRow?.id);

const getNOPOEditedRowId = createSelector(noPO, ({ editedRowId }) => editedRowId);

const getNOPOLeftTableRows = createSelector(noPO, ({ leftTableRows }) => leftTableRows);

const getNOPONotModifiedRow = createSelector(noPO, ({ notModifiedRow }) => notModifiedRow);

export default {
  selectActionsTableView,
  selectTableToSearch,
  getATcompanies,
  getSelectedCompanies,
  getLeftTableRows,
  getSelectedRow,
  getSelectedOptionValue,
  getCorporateApprovalList,
  getSelectedCorporateApproval,
  getAP2OptionList,
  getSelectedRowId,
  getEditedRowId,
  getWfCasuals,
  getWfDefinitions,
  getAllMicrocategories,
  getAllSubjects,
  getOptionDescriptionDropdown,
  getOptionValueDropdown,
  getNotModifiedRow,
  getSelectedAP2row,
  getEditedRowAP2ID,
  getIsEditAP2Template,
  getTemplateAP2List,
  getIsAddAP2Template,
  getVendorListAp2Template,
  getEditedRowIdCorporateApproval,
  getNOPOSelectedRow,
  getNOPOSelectedRowId,
  getNOPOEditedRowId,
  getNOPOLeftTableRows,
  getNOPONotModifiedRow,
};
